import { MenuItem } from "@mui/material";
import { Proposal } from "generated/graphql";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function ViewProposalMenuItem({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: Proposal["id"];
}) {
  return (
    <MenuItem
      data-test-id="action-view"
      component={Link}
      onClick={closeMenu}
      to={getRoute("proposals.view", [["proposalId", id]])}
    >
      View (Read-Only)
    </MenuItem>
  );
}
